<template>
  <Modal
    class="cc-modal"
    width="800"
    footer-hide
    v-model="visibility"
    title="查看域名证书"
  >
    <div class="content" v-if="data">
      <loading
        class="fixed"
        :loading="data.loading"
        style="z-index: 11"
      ></loading>
      <img :src="data.path" style="width: 100%" />
    </div>
    <div class="foot">
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import loading from "components/loading.vue";
export default {
  name: "domainCertificateModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    onCancel() {
      this.visibility = false;
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.fixed {
  top: 51px;
  bottom: 64px;
  transform: translateX(-50%);
  height: auto;
}
</style>
